import { mediaObjectToString } from "../hooks/useMedia";
const MEDIA_SEP = "_";
let prefixes = null;
let selectors = null;
const createMediaStyle = ({ property, identifier, rules }, mediaKey, mediaQueries, negate) => {
  if (!(prefixes && selectors)) {
    const mediaKeys = Object.keys(mediaQueries);
    prefixes = Object.fromEntries(
      mediaKeys.map((key, index) => [key, new Array(index + 1).fill(":root").join("")])
    );
    selectors = Object.fromEntries(
      mediaKeys.map((key) => [key, mediaObjectToString(mediaQueries[key])])
    );
  }
  const precendencePrefix = prefixes[mediaKey];
  const mediaSelector = selectors[mediaKey];
  const negKey = negate ? "0" : "";
  const ogPrefix = identifier.slice(0, identifier.indexOf("-") + 1);
  const nextIdentifier = `${identifier.replace(
    ogPrefix,
    `${ogPrefix}${MEDIA_SEP}${mediaKey}${negKey}${MEDIA_SEP}`
  )}`;
  const screenStr = negate ? "not all and" : "";
  const mediaQuery = `${screenStr} ${mediaSelector}`;
  const styleInner = rules.map((rule) => rule.replace(identifier, nextIdentifier)).join(";");
  let styleRule = "";
  if (styleInner.includes("@media")) {
    styleRule = styleInner.replace("{", ` and ${mediaQuery} {`);
  } else {
    styleRule = `@media ${mediaQuery} { ${precendencePrefix} ${styleInner} }`;
  }
  return {
    property,
    rules: [styleRule],
    identifier: nextIdentifier
  };
};
export {
  MEDIA_SEP,
  createMediaStyle
};
//# sourceMappingURL=createMediaStyle.js.map
